'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsNoble = undefined;
exports.getUniqueResultYears = getUniqueResultYears;
exports.getEntryResults = getEntryResults;
exports.getEventResults = getEventResults;
exports.countEventResults = countEventResults;
exports.getEventCourseResults = getEventCourseResults;
exports.countEventCourseResults = countEventCourseResults;
exports.matchBibInEventResults = matchBibInEventResults;
exports.matchTextInEventResults = matchTextInEventResults;
exports.getResultByEventAndBib = getResultByEventAndBib;

var _EventsNoble = require('./EventsNoble');

var _ErosApi = require('../apis/ErosApi');

var _ChronotrackApi = require('../apis/ChronotrackApi');

var _bastetjs = require('bastetjs');

var _rx = require('rx');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

////////////////////////////////////////////////////////////////
// Past Result Years.

function getUniqueResultYears(_ref) {
  var masterId = _ref.masterId;
  var beforeEpoch = _ref.beforeEpoch;

  return _EventsNoble.EventsNoble.getAllEventsByMasterId({ masterId: masterId }).map(function (msg) {
    var haveYear = {};

    var years = msg.filter(function (_) {
      return _.event.eventEpoch !== null && _.event.startEpoch < beforeEpoch;
    }).map(function (_) {
      var start = _.event.startEpoch;
      var year = start ? new Date(start * 1000).getFullYear() : 0;

      var pair = {
        year: haveYear[year] ? 0 : year,
        eventId: _.event.athlinksId
      };

      haveYear[year] = true;
      return pair;
    }).filter(function (_) {
      return _.year > 0;
    });

    return {
      isLoading: false,
      years: years
    };
  });
}

////////////////////////////////////////////////////////////////
// Athlinks Event Results.

function _getEventResultFields() {
  return ['entryId', 'eventId', 'masterId', 'courseId', 'eventCourseId', 'eventName', 'courseName', 'coursePattern', 'legCount', 'overallRank', 'overallCount', 'genderRank', 'genderCount', 'ageRank', 'ageCount', 'racerId', 'firstName', 'lastName', 'displayName', 'gender', 'age', 'city', 'stateProvId', 'stateProv', 'countryId', 'countryId3', 'isClaimed', 'showPersonalData', 'racerResultCount', 'entryDate', 'ticks', 'ticksString', 'bibNumber', 'sponsor', 'searchText'];
}

function _countResults(msg) {
  var groupBy = msg.groupBy || [];

  if ('isLoading' in msg && msg.isLoading) {
    return 0;
  } else if (groupBy.length > 1) {
    return groupBy.reduce(function (acc, group) {
      acc[group.key] = group.total.value;
      return acc;
    }, {});
  } else {
    return groupBy.length && groupBy[0].total.value || 0;
  }
}

function _assembleEventResultRecords(msg, hits) {
  return 'isLoading' in msg && msg.isLoading ? [] : hits.map(function (hit) {
    return _bastetjs.utils.entityDecoder.decode(hit);
  });
}

function _courseToResults(results, topN) {
  return (results || []).reduce(function (acc, elem) {
    acc[elem.eventCourseId] = acc[elem.eventCourseId] || [];
    acc[elem.eventCourseId].length < topN && acc[elem.eventCourseId].push(elem);
    return acc;
  }, {});
}

function _eventResultQuery(query, size, sort, from) {
  return {
    _source: _getEventResultFields(),
    size: size || 10,
    from: from || 0,
    sort: sort || [{ overallRank: { order: 'asc' } }],
    query: query,
    aggs: {
      groupBy: {
        terms: { field: 'eventCourseId' },
        aggs: { total: { value_count: { field: 'eventCourseId' } } }
      }
    }
  };
}

function _doEventResultQuery(index, streamId, body, size, sort, from) {
  index = index || 'result_bkt_*/overall';
  var query = _eventResultQuery(body, size, sort, from);
  return _ErosApi.ErosApi.memoizeQuery(streamId, index + '/_search', query);
}

function _queryEventCourseResults(index, streamId, query, params, mapCallback) {
  var topN = params.topN || 20;
  return _doEventResultQuery(index, streamId, query, topN, null, params.from).map(mapCallback);
}

function _queryEventResults(index, streamId, query, params, mapCallback) {
  var size = (params.topN || 10) * (params.maxExpectedNumCourses || 50);
  return _doEventResultQuery(index, streamId, query, size, null, params.from).map(mapCallback);
}

function _getDivisionResultIndex(divisionId) {
  return divisionId ? 'result_bkt_*/division' : null;
}

function _queryWithDivisionId(clause, divisionId) {
  return divisionId ? { bool: { must: [clause, { term: { divisionId: divisionId } }] } } : clause;
}

function getEntryResults(_ref2) {
  var entryId = _ref2.entryId;

  var streamId = 'GetEntryResults-' + entryId;
  return _doEventResultQuery(null, streamId, { term: { entryId: entryId } }, 1).map(function (msg) {
    return _assembleEventResultRecords(msg, msg.hits || []);
  });
}

function getEventResults(_ref3) {
  var eventId = _ref3.eventId;
  var divisionId = _ref3.divisionId;

  var params = _objectWithoutProperties(_ref3, ['eventId', 'divisionId']);

  var streamId = 'GetEventResults-' + eventId;
  var query = _queryWithDivisionId({ term: { eventId: eventId } }, divisionId);
  var index = _getDivisionResultIndex(divisionId);
  return _queryEventResults(index, streamId, query, params, function (msg) {
    var results = _assembleEventResultRecords(msg, msg.hits || []);
    return _courseToResults(results, params.topN || 10);
  });
}

function countEventResults(_ref4) {
  var eventId = _ref4.eventId;
  var divisionId = _ref4.divisionId;

  var params = _objectWithoutProperties(_ref4, ['eventId', 'divisionId']);

  var streamId = 'CountEventResults-' + eventId;
  var query = _queryWithDivisionId({ term: { eventId: eventId } }, divisionId);
  var index = _getDivisionResultIndex(divisionId);
  var callback = function callback(_) {
    return _countResults(_);
  };
  return _queryEventResults(index, streamId, query, params, callback);
}

function getEventCourseResults(_ref5) {
  var eventCourseId = _ref5.eventCourseId;
  var divisionId = _ref5.divisionId;

  var params = _objectWithoutProperties(_ref5, ['eventCourseId', 'divisionId']);

  var streamId = 'GetEventCourseResults-' + eventCourseId;
  var query = _queryWithDivisionId({ term: { eventCourseId: eventCourseId } }, divisionId);
  var index = _getDivisionResultIndex(divisionId);
  return _queryEventCourseResults(index, streamId, query, params, function (msg) {
    return _assembleEventResultRecords(msg, msg.hits || []);
  });
}

function countEventCourseResults(_ref6) {
  var eventCourseId = _ref6.eventCourseId;
  var divisionId = _ref6.divisionId;

  var params = _objectWithoutProperties(_ref6, ['eventCourseId', 'divisionId']);

  var streamId = 'CountEventCourseResults-' + eventCourseId;
  var query = _queryWithDivisionId({ term: { eventCourseId: eventCourseId } }, divisionId);
  var index = _getDivisionResultIndex(divisionId);
  var callback = function callback(_) {
    return _countResults(_);
  };
  return _queryEventCourseResults(index, streamId, query, params, callback);
}

function matchBibInEventResults(_ref7) {
  var eventId = _ref7.eventId;
  var bibNumber = _ref7.bibNumber;

  var query = {
    bool: { must: [{ term: { eventId: eventId } }], should: [{ match: { bibNumber: bibNumber } }] }
  };
  var streamId = 'MatchBibInEventResults-' + eventId;
  return _doEventResultQuery(null, streamId, query, 100, [{ _score: { order: 'desc' } }]).map(function (msg) {
    return _assembleEventResultRecords(msg, msg.hits || []).filter(function (_) {
      return _.bibNumber.indexOf(bibNumber) >= 0;
    });
  });
}

function matchTextInEventResults(_ref8) {
  var eventId = _ref8.eventId;
  var searchText = _ref8.searchText;
  var topN = _ref8.topN;

  searchText = searchText.trim().toLowerCase();
  topN = topN || 10;

  if (!eventId || !searchText) {
    return _rx.Observable.just([]);
  }

  var numeric = searchText.match(/\d+/);
  var bibObservable = numeric ? matchBibInEventResults({ eventId: eventId, bibNumber: searchText }) : _rx.Observable.just([]);

  var query = {
    bool: { must: [{ match: { searchText: searchText } }], filter: [{ term: { eventId: eventId } }] }
  };
  var streamId = 'MatchTextInEventResults-' + eventId;
  var textObservable = numeric ? _rx.Observable.just([]) : _doEventResultQuery(null, streamId, query, topN, [{ _score: { order: 'desc' } }]).map(function (msg) {
    return _assembleEventResultRecords(msg, msg.hits || []);
  });

  return _rx.Observable.combineLatest(bibObservable, textObservable).map(function (both) {
    return _courseToResults(both[0].length ? both[0] : both[1], topN);
  });
}

function getResultByEventAndBib(_ref9) {
  var event = _ref9.event;
  var bib = _ref9.bib;

  if (!event || !bib) return _rx.Observable.just({});

  var query = {
    _source: ['eventId', 'genId', 'entryId', 'bib'],
    query: {
      bool: {
        must: [{ term: { eventId: event.id } }, { term: { bib: bib } }]
      }
    }
  };

  return _ErosApi.ErosApi.memoizeQuery('getResultByEventAndBib', 'result_bkt_*/ctlive/_search', query).flatMap(function (erosMsg) {
    var first = _assembleEventResultRecords(erosMsg, erosMsg.hits || [])[0];
    if (!first) return _rx.Observable.just({});
    var path = 'results/' + first.eventId + '/entry/' + first.entryId;
    return _ChronotrackApi.ChronotrackApi.memoizeQuery('getResultByEventAndBibApi', path);
  });
}

// For testing.
var ResultsNoble = exports.ResultsNoble = {
  getUniqueResultYears: getUniqueResultYears,
  matchBibInEventResults: matchBibInEventResults,
  matchTextInEventResults: matchTextInEventResults,
  countEventCourseResults: countEventCourseResults,
  getEventCourseResults: getEventCourseResults,
  countEventResults: countEventResults,
  getEventResults: getEventResults,
  getEntryResults: getEntryResults,
  getResultByEventAndBib: getResultByEventAndBib
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/ResultsNoble.js
// module id = 174
// module chunks = 0